function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

export { expandToHashMap as e };
//# sourceMappingURL=expandToHashMap-BpssOXdr.js.map
